import { lazy } from 'react'

import Dettagli from './dettagli'

export default {
    path: '/ticket',
    title: 'Ticket',
    authenticated: true,
    component: lazy(() => import('./filter')),
    pages: [
        {
            path: '/:ticketId',
            title: 'Ticket: {{params.ticketId}}',
            drawer: false,
            component: lazy(() => import('./detail')),
            pages: [Dettagli]
        }
    ]
}